import {ErrorPriority} from "../../enums/ErrorPriority";
import {NavigationVisitor} from "../navigation/NavigationVisitor";
import {Tenant} from "../tenant/Tenant";
import {TenantApplication} from "../tenant/TenantApplication";
import {BaseError} from "./BaseError";
import {ErrorLog} from "./ErrorLog";

export class LogMessage extends BaseError {
    private static DESCRIPTION_KEY = "error.name.log";

    description: string;
    content: string;

    constructor(id: string, tenant: Tenant, application: TenantApplication, mostRecentOccurred: Date | string, occurrenceCount: number,
                errorPriority: ErrorPriority, isSolved: boolean, description: string, content: string, errorlogs?: ErrorLog[], solution?: string) {
        super(id, tenant, application, mostRecentOccurred, occurrenceCount, errorPriority, isSolved, errorlogs, solution);
        this.description = description;
        this.content = content;
    }

    public override accept(visitor: NavigationVisitor, openNewTab: boolean = false): void {
        visitor.visitLogMessage(this, openNewTab);
    }

    public override get descriptionKey(): string {
        return LogMessage.DESCRIPTION_KEY;
    }

    protected override getContentForSummary(): string {
        return this.content;
    }
}
